import { FieldDefinition, FieldBuilder, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories } from '@zendra/shared';
import { WorkFrontService } from '../proxy/controlling/controllers/work-front.service';
import { MachineService } from '@general/proxy/general/controllers/machine.service';

//FieldBuilder.setNamespace('Controlling');

export const MACHINEPERWORKFRONT_FIELDS: FieldDefinition[] = [
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('machineId', 'General::Entity.Machine', MachineService)
    .required()
    .display('name') 
    .keyField('id') 
    .build(),
  FieldBuilder
    .foreignKey('workFrontId', 'Controlling::Entity.WorkFront', WorkFrontService)
    .required()
    .displayFromNested('workFront.name') 
    .sortBy('workFront.name') 
    .hideInChildForms()
    .build(),
];

export const MACHINEPERWORKFRONT_CONFIG = {
  entityName: 'MachinePerWorkFront',
  localizationKey: 'Controlling::Entity.MachinePerWorkFront',
  fields: MACHINEPERWORKFRONT_FIELDS,
  permission: 'ControllingStructural.MachinePerWorkFronts',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
